import { Pressable, Text } from "react-native";
import { Feather } from "@expo/vector-icons";
import { DialogTitle } from "@radix-ui/react-dialog";

import {
  SaveFormValues,
  stepHasErrors,
  useSaveFormContext,
} from "~/components/SaveForm/shared";
import { cn } from "~/lib/utils";

function BreadcrumbButton({
  step,
  children,
}: {
  step: SaveFormValues["step"];
  children: React.ReactNode;
}) {
  const { getValues, setValue, formState } = useSaveFormContext();
  const currentStep = getValues("step");
  const stepErrorsGetter = stepHasErrors(formState.errors);

  function getClassNameForStep(step: typeof currentStep) {
    if (stepErrorsGetter(step)) {
      return "text-text-warning";
    }

    if (step === currentStep) {
      return "text-text-primary";
    }

    return "text-text-secondary";
  }

  return (
    <Pressable
      role="button"
      onPress={() => {
        setValue("step", step);
      }}
    >
      <Text className={cn(getClassNameForStep(step), "text-lg")}>
        {children}
      </Text>
    </Pressable>
  );
}

export function SaveFormBreadcrumbs() {
  const { getValues } = useSaveFormContext();
  const saveType = getValues("type");
  const isUpdating = getValues("intent") === "update";

  return (
    <DialogTitle className="flex flex-row items-center gap-2">
      {(() => {
        if (saveType === "URL") {
          return (
            <BreadcrumbButton step="addUrl">
              {isUpdating ? "Edit Link" : "Add Link"}
            </BreadcrumbButton>
          );
        }

        if (saveType === "MEDIA") {
          return (
            <BreadcrumbButton step="showAsset">
              {isUpdating ? "Edit Media" : "Add Media"}
            </BreadcrumbButton>
          );
        }

        if (saveType === "FILE") {
          return (
            <BreadcrumbButton step="showAsset">
              {isUpdating ? "Edit File" : "Add File"}
            </BreadcrumbButton>
          );
        }

        if (saveType === "NOTE") {
          return (
            <BreadcrumbButton step="takeNote">
              {isUpdating ? "Edit Note" : "Add Note"}
            </BreadcrumbButton>
          );
        }
      })()}

      <Feather name="chevron-right" className="text-text-primary" size={18} />

      <BreadcrumbButton step="selectLocation">Select Location</BreadcrumbButton>

      <Feather name="chevron-right" className="text-text-primary" size={18} />

      <BreadcrumbButton step="form">Info</BreadcrumbButton>
    </DialogTitle>
  );
}
